import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../layouts/AuthLayout'
import { Box, Text, Flex, Pagination, Modal, ScrollArea, Button, TextInput, Select } from '@mantine/core'
import classes from '../Auth.module.css'
import { getListParameter, deleteParameter } from '../../../services/parameter'
import TableSkeleton from '../../../components/ui/TableSkeleton'
import { modalDeleteData } from '../../../components/ui/ModalManager/modalDeleteData'
import TableParameters from '../../../components/pages/Parameter/TableParameters'
import FormParameters from '../../../components/pages/Parameter/FormParameters'
import { useSelector } from 'react-redux'

const defaultParameter = {
  skip: 0,
  take: 10,
  search: '',
  orderBy: 'order',
  order: 'desc'
}

const defaultFilter = [
  {
    value: 'createdAt',
    label: 'Terbaru'
  },
  {
    value: 'name',
    label: 'Nama'
  },
  {
    value: 'order',
    label: 'Order'
  },
]

const labelTable = [
  {
    label: 'No.',
    width: 30
  },
  {
    label: 'Nama',
    width: 'auto'
  },
  {
    label: 'Sektor Perusahaan',
    width: 'auto'
  },
  {
    label: 'Aspek',
    width: 'auto'
  },
  {
    label: 'Satuan Unit',
    width: 'auto'
  },
  {
    label: 'Jumlah Pengkali',
    width: 'auto'
  },
  {
    label: 'Pembagi Parameter',
    width: 'auto'
  },
  {
    label: 'Produksi Utama',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 100
  },
]


const Parameter = () => {
  const permissionState = useSelector(state => state.permission.access)
  const [params, setParams] = useState(defaultParameter)
  const [parameterList, setParameterList] = useState([])
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(true)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)
  const [selectedFilter, setSelectedFilter] = useState('createdAt')
  const [selectedOrder, setSelectedOrder] = useState('desc')

  const mappingOrder = [
    {
      value: 'asc',
      label: selectedFilter === 'name' ? 'A - Z' : 'Terlama - Terbaru'
    },
    {
      value: 'desc',
      label: selectedFilter === 'name' ? 'Z - A' : 'Terbaru - Terlama'
    },
  ]

  const handleGetParameterList = async () => {
    setLoading(true)
    try {
      const response = await getListParameter(params)
      setParameterList(response.data)
      setCount(response.count)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleGetParameterList()
    // eslint-disable-next-line
  }, [params])

  const handleSearchChange = (e) => {
    const parameter = {
      skip: 0,
      take: 10,
      search: e.target.value,
      orderBy: params.orderBy,
      order: params.order
    }
    setParams(parameter)
  }

  const handleChangePage = (e) => {
    const parameter = {
      skip: (e - 1) * 10,
      take: 10,
      search: params.search,
      orderBy: params.orderBy,
      order: params.order
    }
    setParams(parameter)
  }

  const handleSelectFilter = (filterOrder) => {
    const parameter = {
      skip: 0,
      take: 10,
      search: params.search,
      orderBy: filterOrder,
      order: params.order
    }
    setParams(parameter)
  }

  const handleSelectOrder = (orders) => {
    const parameter = {
      skip: 0,
      take: 10,
      search: params.search,
      orderBy: params.orderBy,
      order: orders
    }
    setParams(parameter)
  }

  const actions = {
    edit: (val) => {
      setOpenModalForm(true)
      setDetailData(val)
    },
    delete: (val) => {
      modalDeleteData('parameter', val.id, val.name, deleteParameter, handleGetParameterList)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  const handleCreate = () => {
    const permissionParameter = permissionState['parameter']
    const createdPermission = permissionParameter.find(val => val.alias === 'parameter.create')
    if (createdPermission !== undefined) {
      return (
        <Button size='xs' color='indigo.9' onClick={() => setOpenModalForm(true)}>Tambah Parameter</Button>
      )
    }
  }

  return (
    <AuthLayout>
      <Box>
        <Text className={classes.titlePage} mb={20}>Manajemen Parameter</Text>
        <Box>
          <Flex justify='flex-end' mb={14}>
            {permissionState !== null ? handleCreate() : ''}
          </Flex>
          <Flex direction={{ base: 'column', sm: 'row' }} gap={{ base: 'sm', sm: 'lg' }} justify={{ base: 'center', lg: 'start' }}>
            <TextInput
              placeholder='Cari Parameter. . .'
              name="search"
              onChange={handleSearchChange}
            />
            <Select
              name="orderBy"
              data={defaultFilter}
              onChange={(e) => [setSelectedFilter(e), handleSelectFilter(e)]}
              value={selectedFilter}
              checkIconPosition="right"
              allowDeselect={false}
            />
            <Select
              name="order"
              data={mappingOrder}
              onChange={(e) => [setSelectedOrder(e), handleSelectOrder(e)]}
              value={selectedOrder}
              checkIconPosition="right"
              allowDeselect={false}
            />
          </Flex>
        </Box>
        <Box my={20}>
          {loading ? <TableSkeleton total={8} /> : <TableParameters label={labelTable} data={parameterList} countData={params.skip} actionMethod={handleAction} />}
        </Box>
        <Flex justify='end'>
          <Pagination onChange={handleChangePage} value={params.skip / 10 + 1} total={Math.ceil(count / params.take) || 0} color='indigo.9' />
        </Flex>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} closeOnClickOutside={false} centered size='lg' title={<Text fw='Bold'>{detailData === null ? 'Tambah' : 'Update'} Parameter</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormParameters dataParameter={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetParameterList} />
      </Modal>
    </AuthLayout>
  )
}

export default Parameter